import { render, staticRenderFns } from "./add-label.vue?vue&type=template&id=176b27af&scoped=true&"
import script from "./add-label.vue?vue&type=script&lang=js&"
export * from "./add-label.vue?vue&type=script&lang=js&"
import style0 from "./add-label.vue?vue&type=style&index=0&id=176b27af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b27af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('176b27af')) {
      api.createRecord('176b27af', component.options)
    } else {
      api.reload('176b27af', component.options)
    }
    module.hot.accept("./add-label.vue?vue&type=template&id=176b27af&scoped=true&", function () {
      api.rerender('176b27af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/add-label.vue"
export default component.exports